import { ReactElement } from "react";
import { Tooltip } from "@mui/material";

const TooltipConditional = ({children, title, condition}: { children: ReactElement<any, any>, title: string, condition: boolean }) => {
  return condition ? <Tooltip title={title}>{children}</Tooltip> : <>{children}</>;
};

export default TooltipConditional;